import request from '../request'
const bankApis = {
  getAllBank: () => request.get('/banks'),
  getMyBank: (payload, query) => request.get(`/users/${payload.userID}/bank-account${query}`),
  createBank: (payload) => request.post(`users/${payload.userID}/bank-account`, payload.formData),
  updateBank: (payload) => request.patch(`users/${payload.userID}/bank-account/${payload.id}`, payload.formData),
  updateBankDefault: (payload) => request.patch(`users/${payload.userID}/bank_account/${payload.id}/default`, payload.formData)
}
export default bankApis;